'use client';

import {
  CcCardListing,
  type CcCardListingProps,
} from '@hyphengroup/cms-components/cms-blocks/CcCardListing';
import { withVerticalScope } from '@hyphengroup/cms-components/utils/cmsPageContext';
import { usePageDataContext } from '$/(cms)/_modules/cmsService/pageDataService/pageDataProvider';
import { getProductBlockVertical } from '$/components/cms/helpers/productBlockVertical';
import { usePdpModalConfigProps } from '$/components/cms/helpers/useProductDetailModal';

// App data the block cannot fetch: the page's market config and the #usePDP modal's fetcher.
const CcCardListingWithMarketConfig: React.FC<CcCardListingProps> = (props) => {
  const { pageData } = usePageDataContext();
  const pdpModalConfig = usePdpModalConfigProps();
  return (
    <CcCardListing
      {...props}
      {...pdpModalConfig}
      config={pageData.page.ccProductCardConfig}
    />
  );
};

// A block's products can belong to another vertical than the page's (CMS-1987).
const CcCardListingWrapper = withVerticalScope<CcCardListingProps>(
  CcCardListingWithMarketConfig,
  (props) => getProductBlockVertical(props.metadata?.product_card),
);

export default CcCardListingWrapper;
